import React, { createContext, useContext, useState, useCallback } from 'react';
import findIndex from 'lodash.findindex';
import { MULTIMEDIA_TYPES } from '../../config';
import { uploadMultimedia, processingImage, multimediaUploaded, createMultimediaProject } from '../../services/uploadingService';
import { createMultimediaSubprojectRequest } from './uploadingUtils';

const UploadingContext = createContext();

export function UploadingProvider({children}) {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submittingAction, setSubmittingAction] = useState(null);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const { Provider } = UploadingContext;

  const uploadingData = {
    submitted,
    setSubmitted,
    submitting,
    setSubmitting,
    submittingAction,
    setSubmittingAction,
    files: uploadFiles,
    setUploadFiles,
    success,
    setSuccess,
    error,
    setError,
  }

  return <Provider value={uploadingData}>{children}</Provider>;
}

export const useUploadingMedia = () => useContext(UploadingContext);